import { useT } from '@/i18n';

/** Slim editorial masthead for the single-column pages (hub / quiz / result / states). */
export function Masthead() {
  const t = useT();
  return (
    <header className="mx-auto flex w-full max-w-3xl items-center gap-3 px-6 pt-7 pb-5">
      <span aria-hidden className="h-5 w-5 rounded-[3px] bg-fixit-600" />
      <span className="font-semibold tracking-tight text-ink-strong">FixIt</span>
      <span aria-hidden className="h-4 w-px bg-line-strong" />
      <span className="hb-eyebrow">{t('Safety training')}</span>
    </header>
  );
}
